// Reglas de contraseña compartidas por los formularios de registro.
// Deben ser iguales o más estrictas que la política configurada en Supabase;
// si no, el fallo aparecería recién al crear el usuario.
export const PASSWORD_MIN = 8;

export const reqLongitud = (pwd: string) => pwd.length >= PASSWORD_MIN;
export const reqLetra = (pwd: string) => /[a-zA-Z]/.test(pwd);
export const reqNumero = (pwd: string) => /\d/.test(pwd);

export const passwordValida = (pwd: string) =>
  reqLongitud(pwd) && reqLetra(pwd) && reqNumero(pwd);

export const requisitosPassword = (
  pwd: string,
  t: (key: string, opts?: Record<string, unknown>) => string
) => [
  { ok: reqLongitud(pwd), label: t('password.reqLength', { min: PASSWORD_MIN }) },
  { ok: reqLetra(pwd), label: t('password.reqLetter') },
  { ok: reqNumero(pwd), label: t('password.reqNumber') },
];